module.exports = __webpack_public_path__ + "static/img/3_8_1.f1ee6514.jpg";